import { ApiPartner as LegacyApiPartnerModel } from "@daytrip/legacy-models";

export class ApiPartnerModel extends LegacyApiPartnerModel {}
